import {
  UPDATE_USER,
  UPDATE_USER_FAILED,
  UPDATE_USER_SUCCEEDED,
  REGISTER_USER,
  REGISTER_USER_FAILED,
  REGISTER_USER_SUCCEEDED,
  CREATE_USER_INBOX,
  CREATE_USER_INBOX_FAILED,
  CREATE_USER_INBOX_SUCCEEDED,
  GET_USER_PROFILE,
  GET_USER_PROFILE_FAILED,
  GET_USER_PROFILE_SUCCEEDED,
  VERIFY_ACCOUNT_EMAIL,
  VERIFY_ACCOUNT_EMAIL_FAILED,
  VERIFY_ACCOUNT_EMAIL_SUCCEEDED,
  RESEND_ACCOUNT_VERIFICATION_EMAIL,
  RESEND_ACCOUNT_VERIFICATION_EMAIL_FAILED,
  RESEND_ACCOUNT_VERIFICATION_EMAIL_SUCCEEDED,
  CLEAR_REGISTER_USER_ERROR,
} from 'Redux/Types/UserTypes'

const INITIAL_STATE = {
  accountVerificationLinkSent: false,
  creating: false,
  creatingUserInbox: false,
  profile: {},
  profileFetched: false,
  registeringUser: false,
  registerUserError: null,
  resendingAccoutVerificationLink: false,
  updated: false,
  updatingUser: false,
  userInboxCreated: false,
  verifyAccountEmail: false,
  verifyAccountEmailFailed: false,
  personas: [],
  selectedCompany: null,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case REGISTER_USER:
      return {
        ...state,
        registeringUser: true,
        registerUserError: null,
      }
    case REGISTER_USER_FAILED:
      return {
        ...state,
        registeringUser: false,
        registerUserError: payload,
      }
    case REGISTER_USER_SUCCEEDED:
      return {
        ...state,
        registeringUser: false,
        profile: payload,
        personas: payload.personas,
        selectedPersona: (payload.personas || [])[0],
      }

    case CREATE_USER_INBOX:
      return {
        ...state,
        creatingUserInbox: true,
        userInboxCreated: false,
      }
    case CREATE_USER_INBOX_FAILED:
      return {
        ...state,
        userInboxCreated: false,
        creatingUserInbox: false,
      }
    case CREATE_USER_INBOX_SUCCEEDED:
      return {
        ...state,
        userInboxCreated: true,
        creatingUserInbox: false,
      }

    case UPDATE_USER: {
      return {
        ...state,
        updated: false,
        updatingUser: true,
      }
    }
    case UPDATE_USER_FAILED: {
      return {
        ...state,
        updated: false,
        updatingUser: false,
      }
    }
    case UPDATE_USER_SUCCEEDED: {
      return {
        ...state,
        updated: true,
        updatingUser: false,
        profile: payload,
      }
    }

    case GET_USER_PROFILE:
      return {
        ...state,
        profileFetched: false,
      }
    case GET_USER_PROFILE_FAILED:
      return {
        ...state,
        profileFetched: false,
      }
    case GET_USER_PROFILE_SUCCEEDED:
      return {
        ...state,
        profile: payload,
        profileFetched: true,
        personas: payload.personas,
        selectedPersona: (payload.personas || [])[0],
      }

    case VERIFY_ACCOUNT_EMAIL:
      return {
        ...state,
        verifyAccountEmail: false,
        verifyAccountEmailFailed: false,
      }
    case VERIFY_ACCOUNT_EMAIL_FAILED:
      return {
        ...state,
        verifyAccountEmail: false,
        verifyAccountEmailFailed: true,
      }
    case VERIFY_ACCOUNT_EMAIL_SUCCEEDED:
      return {
        ...state,
        verifyAccountEmail: true,
        verifyAccountEmailFailed: false,
      }

    case RESEND_ACCOUNT_VERIFICATION_EMAIL:
      return {
        ...state,
        accountVerificationLinkSent: false,
        resendingAccoutVerificationLink: true,
      }
    case RESEND_ACCOUNT_VERIFICATION_EMAIL_FAILED:
      return {
        ...state,
        accountVerificationLinkSent: false,
        resendingAccoutVerificationLink: false,
      }
    case RESEND_ACCOUNT_VERIFICATION_EMAIL_SUCCEEDED:
      return {
        ...state,
        accountVerificationLinkSent: true,
        resendingAccoutVerificationLink: false,
      }

    case CLEAR_REGISTER_USER_ERROR:
      return { ...state, registerUserError: null }
    default:
      return state
  }
}
